const PTDictionary = [
    'nunca',
    'mundo',
    'certeza',
    'irmão',
    'arma',
    'juntos',
    'acreditar',
    'seguro',
    'vontade',
    'barco',
    'interessa',
    'povo',
    'serviço',
    'saiu',
    'horrível',
    'regras',
    'contrário',
    'inteligente',
    'universidade',
    'confiar',
    'férias',
    'tamanho',
    'puder',
    'calhar',
    'universo',
    'atacar',
    'dois',
    'espera',
    'momento',
    'morrer',
    'trabalhar',
    'gostaria',
    'dizem',
    'estiver',
    'decisão',
    'cerveja',
    'missão',
    'resolver',
    'preocupado',
    'precisava',
    'unidos',
    'mudança',
    'apoio',
    'propriedade',
    'fazer',
    'pequeno',
    'demais',
    'sala',
    'engraçado',
    'normal',
    'destino',
    'energia',
    'caixa',
    'preparar',
    'compreendo',
    'comum',
    'diante',
    'investigação',
    'ouvido',
    'patrão',
    'encontramos',
    'controlar',
    'servir',
    'agradecer',
    'forma',
    'telefone',
    'completamente',
    'doutor',
    'pior',
    'tom',
    'cabo',
    'piada',
    'nariz',
    'ação',
    'testemunha',
    'amar',
    'problemas',
    'mostrar',
    'inglês',
    'ministro',
    'rapaz',
    'banco',
    'infelizmente',
    'vender',
    'posição',
    'local',
    'tiro',
    'peça',
    'pele',
    'direção',
    'fumar',
    'cidade',
    'irá',
    'incrível',
    'existem',
    'copo',
    'fizer',
    'magia',
    'jogos',
    'cinema',
]


export default PTDictionary;